module.exports = __webpack_public_path__ + "media/images/front/services/design-e4c394eecd2700c9529c0c0b8584e55d.jpg";